module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.3.6-234.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.3.6.md
// module id = 677
// module chunks = 300